(function () {
  var PIXEL = '1030334442915208';
  // Meta-Base laden + init OHNE PageView (PageView/ViewContent kommen bereits ueber Shopify-Web-Pixel)
  if (!window.fbq) {
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', PIXEL);
  }
  function atc(id, priceCents) {
    try {
      fbq('track', 'AddToCart', {
        content_ids: [String(id)], content_type: 'product',
        value: (priceCents || 0) / 100, currency: 'EUR'
      });
    } catch (e) {}
  }
  // Jeden erfolgreichen /cart/add-Aufruf abfangen (nativ + Sticky + Cart-Upsell)
  var of = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = (args[0] && args[0].url) || args[0];
    var p = of.apply(this, args);
    if (typeof url === 'string' && url.indexOf('/cart/add') > -1) {
      p.then(function (res) {
        if (!res || !res.clone) return;
        res.clone().json().then(function (data) {
          var items = data && data.items ? data.items : (data && data.id ? [data] : []);
          items.forEach(function (it) {
            if (it && it.id) atc(it.id, it.price != null ? it.price : it.final_price);
          });
        }).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };
})();
